import * as React from "react";
const SvgSoccerHalf = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={424} height={550} {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 1h422v548H1z" />
      <path d="M1.25 244h4v61h-4zM89.859 275.281c.001-2.574 2.393-4.594 4.931-4.158s4.124 3.134 3.266 5.564c-1.537 4.353-8.197 3.21-8.197-1.406" />
      <path d="M1.266 352.569h46.406V197.994H1.266" />
      <path d="M1.266 244.4V105.182h139.218v340.23H1.266V306.163z" />
      <path d="M140.484 213.582c8.875 6.801 16.289 15.28 21.594 25.144a77.4 77.4 0 0 1 9.061 31.882 77.5 77.5 0 0 1-5.142 32.743 77.4 77.4 0 0 1-18.398 27.568c-2.251 2.165-4.638 4.165-7.116 6.061M427.359 275.281c0-2.574-2.394-4.594-4.931-4.158s-4.124 3.134-3.265 5.564c1.537 4.351 8.198 3.212 8.196-1.406M1.266 541.063c4.598-.021 8.435 3.858 8.438 8.438M1.266 9.5c4.598-.003 8.435-3.839 8.438-8.438" />
      <path d="M500.344 275.281c-.1-11.24-2.443-22.333-7.193-32.542a77.46 77.46 0 0 0-20.243-26.479 77.5 77.5 0 0 0-29.515-15.478 77.4 77.4 0 0 0-33.292-1.595 77.5 77.5 0 0 0-30.86 12.587 77.5 77.5 0 0 0-22.68 24.422 77.5 77.5 0 0 0-10.272 31.707 77.4 77.4 0 0 0 4.051 33.081 77.5 77.5 0 0 0 17.617 28.292 77.4 77.4 0 0 0 27.902 18.228 77.45 77.45 0 0 0 32.984 4.77 77.4 77.4 0 0 0 31.925-9.58 77.4 77.4 0 0 0 24.908-22.143 77.6 77.6 0 0 0 13.255-30.58c.944-4.846 1.369-9.756 1.413-14.69" />
    </g>
  </svg>
);
export default SvgSoccerHalf;
